<div class="ant-card-meta-avatar" *ngIf="dwAvatar">
  <ng-template [ngTemplateOutlet]="dwAvatar"></ng-template>
</div>
<div class="ant-card-meta-detail" *ngIf="dwTitle || dwDescription">
  <div class="ant-card-meta-title" *ngIf="dwTitle">
    <ng-container *ngIf="isTitleString; else titleTemplate">{{ dwTitle }}</ng-container>
    <ng-template #titleTemplate>
      <ng-template [ngTemplateOutlet]="dwTitle"></ng-template>
    </ng-template>
  </div>
  <div class="ant-card-meta-description" *ngIf="dwDescription">
    <ng-container *ngIf="isDescriptionString; else descriptionTemplate">{{ dwDescription }}</ng-container>
    <ng-template #descriptionTemplate>
      <ng-template [ngTemplateOutlet]="dwDescription"></ng-template>
    </ng-template>
  </div>
</div>